import React from 'react';

import { useAuthService, AuthContext } from '@/controllers';
import { FCC } from '@/utils/types';

const AuthProvider: FCC = ({ children }) => {
  const authState = useAuthService();

  return (
    <AuthContext.Provider value={authState}>
      {!!authState.username && children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
